<template>
  <div id="sitemap_container">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
    <h1 class="page-title">Visualize</h1>
    <div v-if="!scanStatus.completed">
        <b-alert variant="primary" show>  <b-spinner label="Loading..." style="font-size:14px;height:20px;width:20px"></b-spinner> Waiting for audit to complete.</b-alert>
    </div>
    <div v-else-if="homePage.pageCount === 1">
      <b-alert variant="dark" show>  Visualization is only available for audits with multiple pages.</b-alert>
    </div>
    <div v-else>
      <b-modal
        v-model="model.show"
        size="xl"
        id="modalPopover"
        :title="model.title"
        hide-footer
      >
        <Widget class="h-100 mb-0">
          <a
            :href="model.url"
            target="_blank"
            v-b-tooltip.hover
            title="External Page"
            >{{ model.url }}</a
          >
          <router-link
            :to="{ name: 'ExplorePageDetails', query: { url: model.path } }"
            v-b-tooltip.hover
            title="Page Details"
            style="float:right"
            ><i class="fa fa-eye"></i> Page Details</router-link
          >
        </Widget>
        <p></p>
        <vue-load-image style="text-align:center">
          <img
            slot="image"
            :src="model.src"
            style="border-radius: 0.25rem;max-width:100%"
          />
          <div
            slot="preloader"
            class="image-loading-container"
            style="width:100%;height:100px"
          >
            <div><b-spinner label="Loading..."></b-spinner><br />Loading..</div>
          </div>
          <div slot="error" class="screenshot-error">
            <p></p>
            <h4>Image Error.</h4>
            <p>
              If this problem persists<br />
              please let us know.
            </p>
            <i class="fa fa-warning"></i>
          </div>
        </vue-load-image>
      </b-modal>

      <div
        :class="{
          container_normal: !canvas.maximized,
          container_maximized: canvas.maximized
        }"
      >
        <template v-if="!model.show">
          <div :class="{maximize_button_normal: canvas.maximized, maximize_button_maximized: !canvas.maximized}">
          <b-dropdown id="dropdown-left" :text="selectedDevice.title" variant="dark" class="m-2">
            <b-dropdown-item v-for="device in activeSite.devices" href="#" @click="setDevice(device)">{{device.title}}</b-dropdown-item>
          </b-dropdown>
          <a
            v-if="!canvas.maximized"
            title="Full Screen"
            href="#here"
            @click="toggleMaximize()"
            style="color:gray"
            ><span class="glyphicon glyphicon-resize-full"></span
          ></a>
          <a
            v-else
            title="Exit Full Screen"
            href="#here"
            @click="toggleMaximize()"
            style="color:gray"
            ><span class="glyphicon glyphicon-resize-small"></span
          ></a>
          </div>
        </template>
        <div
          id="graph"
          :class="{
            canvas_normal: !canvas.maximized,
            canvas_maximized: canvas.maximized
          }"
        ></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import gql from "graphql-tag";
import ForceGraph from "force-graph";
import { mapState } from "vuex";
import VueLoadImage from "vue-load-image";
let graphdata = { nodes: [], links: [] };
let highlightLinks = new Set();
let highlightNodes = new Set();
let hoverNode = null;
let hoverTween = 0;
let hoverTweenStart = 0;
let forceGraph = {};
import Widget from "@/components/Widget/Widget";
export default {
  name: "Sitemap",
  components: { Widget, "vue-load-image": VueLoadImage },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription {
            websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
              id
              url
              websites_crawledpages(where: {ready: {_eq: true}, is_latest: {_eq: true}, status: {_lt: 300, _gte: 200}}, limit: ${this.pageSize}, offset: ${(this.currentPage - 1) * this.pageSize || 0}, order_by: {level: asc, id: asc}) {
                title
                id
                crawl_date
                level
                url
                path

                websites_devicerenders{
                  id
                  device_id
                  screenshots
                }

                 websites_link_pages{
                  websites_link{
                    final_url
                  }
                }

              }
              websites_crawledpages_aggregate(where: {ready: {_eq: true}, is_latest: {_eq: true}, status: {_lt: 300, _gte: 200}}){
                aggregate {
                  count
                }
              }

            }
          }`;
        },
        skip() {
          return (
            !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed)
          );
        },
        result(data) {
            this.loadGraph(data);
        }
      }
    }
  },
  data() {
    return {
      lighthouseEndpoint: axios.defaults.baseURL + "lighthouse",
      pages: [],
      crawlVersion: 0,
      currentPage: 1,
      numberOfPages: 1,
      hasuraData: {},
      pageCount: 1,
      selectedDevice: {id: 'chrome', title: 'Desktop (1366x768)', width: 1366, height: 768},
      canvas: {
        maximized: false
      },
      model: {
        show: false,
        title: "hello",
        src: ""
      },
      pageSize: 250,
      highlightNodes: new Set(),
      highlightLinks: new Set(),
      hoverNode: null,

      completed: false,
      images: [
        "https://ik.imagekit.io/pagewatch/w/f7bc802babd3493795d2f3e92735ded1/1248/4700076107f48df801ac2d31106d4a22/main.png?tr=w-380"
      ],
      graph: {
        nodes: [],
        links: []
      },
      error: "",
      submitting: false,
      hoverTween: 0,
      hoverTweenStart: 0,
      loading: true,
      dataLoaded: false,
      userHasActivePlan: false,
      subscription: {},
      price: {
        starter: { base: 45, perPage: 0.0 },
        pro: { base: 155, perPage: 0.0 },
        agency: { base: 435, perPage: 0.0 }
      },
      form: {
        numberOfPages: 150
      }
    };
  },
  metaInfo: {
    title: "Sitemap - PageWatch.dev"
  },
  methods: {
    setDevice(device){
      this.selectedDevice=device;
      this.loadGraph(this.hasuraData, true);
    forceGraph.graphData(graphdata)
    },
    loadGraph(data, skip=false){
      this.hasuraData = data;

      graphdata.nodes = [];
      graphdata.links = [];
      this.pageCount = 0;
      this.numberOfPages = 1;
      if (data.data.websites_website && data.data.websites_website.length) {
        this.homePage = data.data.websites_website[0];

          this.homePage.pageCount =
                  data.data.websites_website[0].websites_crawledpages_aggregate.aggregate.count;
          if (this.homePage.pageCount) {
            this.pageCount = this.homePage.pageCount;
            this.numberOfPages = Math.ceil(this.pageCount / this.pageSize);
            if (this.currentPage > this.numberOfPages) {
              this.$router.push({ name: "ExplorePage" });
            }

            this.pages =
                    data.data.websites_website[0].websites_crawledpages;
            let nodeIds = [];
            let i = 0;
            for (let page of this.pages) {
              page.screenshots = {};
              page.layout_errors_count = 0;

              for (let s of page.websites_devicerenders) {
                if (s.device_id !== this.selectedDevice.id){
                  continue;
                }
                i += 1;
                page.layout_errors_count += s.layout_errors_count;
                page.screenshots[s.device_id] = s.screenshots;

                let img = new Image();
                //       img.src = s.screenshots.main.screenshot.url + '?tr=w-400';

                let imageReq = new XMLHttpRequest();

                if (s.screenshots.main.screenshot.url) {  // ignore broken images (eg failed to upload via backblaze)
                  imageReq.open(
                          "GET",
                          s.screenshots.main.screenshot.url + "?tr=w-400",
                          true
                  );

                  imageReq.responseType = "blob";

                  imageReq.onload = imageEvent => {
                    var blob = imageReq.response;
                    if (imageReq.status === 200) {
                      let urlCreator = window.URL || window.webkitURL;
                      let imageUrl = urlCreator.createObjectURL(blob);
                      img.src = imageUrl;
                    }
                  };
                  imageReq.send(null);
                }
                //       img.src = 'https://ik.imagekit.io/pagewatch/w/fe803d3c61d4415d882e756001c56ab7/1376/fe1a2d327d8800889928d6d41a3f8360/galaxy_s6_main.png?tr=w-100'
                graphdata.nodes.push({
                  id: page.url,
                  img: img,
                  fullSrc: s.screenshots.full.screenshot.url,
                  title: page.title,
                  path: page.path
                });
                nodeIds.push(page.url);
                break;
              }
            }
            for (let page of this.pages) {
              for (let link of page.websites_link_pages) {
                if (page.url == link.websites_link.final_url) {
                  continue;
                }

                if (nodeIds.indexOf(link.websites_link.final_url) !== -1) {
                  graphdata.links.push({
                    source: page.url,
                    target: link.websites_link.final_url
                  });
                  let node1 = graphdata.nodes.find(v => {
                    return v.id === page.url;
                  });
                  let node2 = graphdata.nodes.find(v => {
                    return v.id === link.websites_link.final_url;
                  });
                  if (!node1.neighbors) {
                    node1.neighbors = [];
                  }
                  if (!node2.neighbors) {
                    node2.neighbors = [];
                  }
                  node1.neighbors.push(node2);
                  node2.neighbors.push(node1);

                  if (!node1.links) {
                    node1.links = [];
                  }
                  if (!node2.links) {
                    node2.links = [];
                  }
                  node1.links.push(
                          graphdata.links[graphdata.links.length - 1]
                  );
                  node2.links.push(
                          graphdata.links[graphdata.links.length - 1]
                  );
                } else {
                }
              }
            }
          }

      }
      this.loading = false;
      this.dataLoaded = true;

      if (!skip){
      if (this.scanStatus.completed && this.homePage.pageCount > 1) {
        this.$nextTick(() => {
          this.drawGraph();
        });
      }
      }
    },
    toggleMaximize() {
      this.canvas.maximized = !this.canvas.maximized;
      if (this.canvas.maximized) {
        forceGraph.width(window.innerWidth);
        forceGraph.height(window.innerHeight-12);
        forceGraph.zoomToFit(1000);
      } else {
        forceGraph.width(
          document.getElementById("sitemap_container").scrollWidth
        );
        forceGraph.height(900);
        forceGraph.zoomToFit(1000);
      }
    },
    showModel(title, url, src, path) {
      this.model.title = title;
      this.model.src = src + "";
      this.model.url = url + "";
      this.model.path = path + "";
      this.model.show = true;
    },
    drawGraph() {
      let graphElement = document.getElementById("graph");
      forceGraph(graphElement)
        .nodeCanvasObject((node, ctx) => {
          let { img, x, y } = node;
          if (!hoverTweenStart) {
            hoverTweenStart = new Date().getTime();
          }
          let elapsed = new Date().getTime() - hoverTweenStart;
          ctx.save();
          ctx.globalAlpha = 1;
          let size = 14;
          if (this.selectedDevice.id === 'chrome'){
            size = 10;
          }
          if (hoverNode) {
            if (hoverTween === 0) {
              hoverTween = 0.001;
            } else {
              if (hoverTween >= 0.9) {
                hoverTween = 0.9;
              } else {
                hoverTween += elapsed / 400;
                hoverTween = Math.min(0.9, hoverTween);
              }
            }
          } else {
            // hoverTween -= (elapsed)/400;
            // hoverTween = Math.max(0, hoverTween);
            // hoverTween = 1 - Math.min(1, (elapsed)/400);
            hoverTween = 0;
          }

          if (hoverNode && !highlightNodes.has(node)) {
            ctx.globalAlpha = 1 - hoverTween;
          } else if (node === hoverNode) {
            size = size + hoverTween * 10;

            ctx.globalAlpha = 1;
          } else if (!hoverNode) {
            ctx.globalAlpha = 1 - hoverTween;
          }

          ctx.drawImage(
            img,
            x - (size / 2) * this.selectedDevice.width /  this.selectedDevice.height,
            y - (size / 2) ,
            size * this.selectedDevice.width / this.selectedDevice.height,
            (size )
          );
          ctx.restore();
          hoverTweenStart = new Date().getTime();
        })
        .graphData(graphdata)
        .width(100).height(900)
        .backgroundColor("#101020")
        .linkColor(link =>
          highlightLinks.has(link)
            ? "rgba(255,0,0,0.2)"
            : "rgba(255,255,255,0.1)"
        )
       .nodeLabel("title")
        .onNodeHover(node => {
          graphElement.style.cursor = node ? "pointer" : "default";
          highlightNodes.clear();
          highlightLinks.clear();
          if (!(node && node.neighbors && node.links)) {
            hoverNode = node || null;
            hoverTween = 0;
            return;
          }

          if (node) {
            highlightNodes.add(node);
            node.neighbors.forEach(neighbor => highlightNodes.add(neighbor));
            node.links.forEach(link => highlightLinks.add(link));
          }

          hoverNode = node || null;
        })
        .onNodeClick((node, event) => {
          this.showModel(node.title, node.id, node.fullSrc, node.path);
        })
        .linkWidth(link =>
          highlightLinks.has(link) ? 3 : hoverNode ? 1 - hoverTween : 1
        );
      // .linkDirectionalParticles(4)
      // .linkDirectionalParticleWidth(link => highlightLinks.has(link) ? 1 : 0)
      // .linkDirectionalArrowLength(link => !graphdata.links.find( (v)=> {return (v.source === link.target && v.target===link.source)}) ? 2 : 0);

      setTimeout(() => {
        this.center();
      }, 1);
    },
    center() {
      this.$nextTick(() => {
        forceGraph.width(this.sitemap_width);
        setTimeout(() => {
          forceGraph.zoomToFit(1000, 350 - Math.min(this.pages.length, 7) * 50);
        }, 1)
      });
    }
  },
  watch: {
    activeSite: function() {
      this.$router.push({name: "Dashboard"});
    },
  },
  computed: {
    ...mapState({ activeSite: "activeSite", scanStatus: "scanStatus" }),
    sitemap_width() {
      return Math.min(914, document.getElementById("sitemap_container").clientWidth - 2);
    }
  },
  beforeDestroy() {
    highlightNodes.clear();
    highlightLinks.clear();
    graphdata = { nodes: [], links: [] };
    if (forceGraph) {
      forceGraph.graphData({ nodes: [], links: [] });
      forceGraph = null;
    }
  },
  created() {
    forceGraph = ForceGraph();
  }
};
</script>

<style lang="scss">
.canvas_normal {
  left: 0;
  top: 0;
}
.canvas_maximized {
  position: absolute;
  left: 0;
  top: 0;
}
.container_normal {
  position: relative;
}
.container_maximized {
}
.maximize_button_normal {
  position: absolute;
  font-size: 24px;
  color: gray;
  float: right;
  top: 0px;
  right: 10px;
  z-index: 90009;
}
.maximize_button_maximized {
  position: absolute;
  font-size: 24px;
  color: gray;
  float: right;
  top: 0px;
  right: 10px;
  z-index: 90009;
}
</style>
